<template>
  <div>
    <popper
      trigger="clickToOpen"
      :options="{
        placement: this.placement,
        modifiers: { offset: { offset: '0,10px' } }
      }"
      @created="onPopperCreated"
    >
      <div
        class="popper"
        :class="{ 'mobileshare': mobile === true }"
      >
        <div class="sharethis-inline-share-buttons"></div>
      </div>

      <a slot="reference">
        <i class="fi flaticon-multimedia"></i>
      </a>
    </popper>
  </div>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  components: {
    'popper': Popper,
  },

  props: {
    data: {},
    mobile: {},
    placement: {
      default: 'top'
    }
  },

  methods: {
    onPopperCreated () {
        const st = window.__sharethis__;
        st.initialize();
    }
  }

}
</script>

<style lang="scss">
.icon-social {
  font-size: 1.4em;
  cursor: pointer;

  span {
    padding: 10px;
  }
}

.popper {
  min-width: 150px;
}

.mobileshare {
  i {
    color: black !important;
  }

  .icon-social {
    display: flex;
  }
}</style>
